import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Avatar,
  IconButton,
  Box,
  Tooltip
} from '@material-ui/core'

import EventAvailableIcon from '@material-ui/icons/EventAvailable'
import { useSelector } from 'react-redux'

import Skeleton from '@material-ui/lab/Skeleton'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontWeight: 700
  },
  avatar: {
    backgroundColor: theme.palette.error.main,
    height: 56,
    width: 56
  },
  icon: {
    height: 32,
    width: 32
  },
  difference: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  differenceIcon: {
    color: theme.palette.error.dark
  },
  differenceValue: {
    color: theme.palette.error.dark,
    marginRight: theme.spacing(1)
  },
  iconButton: {
    color: 'white'
  }
}))

const Budget = props => {
  const { className, ...rest } = props

  const classes = useStyles()

  const numberOfEvents = useSelector(state => state.bookingInfo.numberOfEvents)

  const eventHeldText = useSelector(state => state.language.text.eventHeld)

  const eventHeldTooltip = useSelector(
    state => state.language.text.eventHeldTooltip
  )

  const isLoading = useSelector(state => state.bookingInfo.isLoading)

  if (isLoading)
    return (
      <Box height={96}>
        <Skeleton variant="rect" height="50%"></Skeleton>
        <Skeleton height={'10%'} />
        <Skeleton height={'10%'} width="60%" />
      </Box>
    )

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent>
        <Grid container justify="space-between">
          <Grid item>
            <Tooltip title={eventHeldTooltip}>
              <Typography
                className={classes.title}
                color="textSecondary"
                gutterBottom
                variant="body2">
                {eventHeldText}
              </Typography>
            </Tooltip>

            <Typography variant="h3">{numberOfEvents}</Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <IconButton className={classes.iconButton}>
                <EventAvailableIcon className={classes.icon} />
              </IconButton>
            </Avatar>
          </Grid>
        </Grid>
        {
          //     duration !== 'Custom' ? (
          //   <div className={classes.difference}>
          //     <ArrowDownwardIcon className={classes.differenceIcon} />
          //     <Typography className={classes.differenceValue} variant="body2">
          //       {confirmedBookingValueSupport}%
          //     </Typography>
          //     <Typography className={classes.caption} variant="caption">
          //       Since last month
          //     </Typography>
          //   </div>
          // ) : (
          //   <div className={classes.difference}>
          //     {/* <Typography className={classes.caption} variant="caption">
          //     Choose fixed duration to show more analytics
          //   </Typography> */}
          //   </div>
          // )
        }
      </CardContent>
    </Card>
  )
}

Budget.propTypes = {
  className: PropTypes.string
}

export default Budget
